// src/enums/common.ts
var Locale = {
  UZ: "uz",
  RU: "ru",
  EN: "en"
};
var LOCALES = Object.values(Locale);
var DEFAULT_LOCALE = Locale.RU;
var PROJECT_TIMEZONE = "Asia/Tashkent";
var CURRENCY = "UZS";
var TIYIN_IN_SUM = 100;

// src/enums/order.ts
var OrderStatus = {
  /** Новый */
  NEW: "NEW",
  /** Ожидает оплаты */
  AWAITING_PAYMENT: "AWAITING_PAYMENT",
  /** Оплачен */
  PAID: "PAID",
  /** Ожидает подтверждения администратором */
  AWAITING_ADMIN_CONFIRMATION: "AWAITING_ADMIN_CONFIRMATION",
  /** Ожидает прохождения MyID */
  AWAITING_MYID: "AWAITING_MYID",
  /** Верификация пройдена */
  VERIFIED: "VERIFIED",
  /** Подготавливается */
  PREPARING: "PREPARING",
  /** Готов к выдаче */
  READY_FOR_PICKUP: "READY_FOR_PICKUP",
  /** Передан в доставку */
  HANDED_TO_DELIVERY: "HANDED_TO_DELIVERY",
  /** Доставлен */
  DELIVERED: "DELIVERED",
  /** Аренда активна */
  RENTAL_ACTIVE: "RENTAL_ACTIVE",
  /** Ожидает возврата */
  AWAITING_RETURN: "AWAITING_RETURN",
  /** Возвращен */
  RETURNED: "RETURNED",
  /** Проверяется складом */
  WAREHOUSE_INSPECTION: "WAREHOUSE_INSPECTION",
  /** Обнаружено повреждение */
  DAMAGE_DETECTED: "DAMAGE_DETECTED",
  /** Начислен штраф */
  FINE_ISSUED: "FINE_ISSUED",
  /** Завершен */
  COMPLETED: "COMPLETED",
  /** Отменен */
  CANCELLED: "CANCELLED"
};
var ORDER_STATUSES = Object.values(OrderStatus);
var TERMINAL_ORDER_STATUSES = [
  OrderStatus.COMPLETED,
  OrderStatus.CANCELLED
];
var RESERVING_ORDER_STATUSES = [
  OrderStatus.NEW,
  OrderStatus.AWAITING_PAYMENT,
  OrderStatus.PAID,
  OrderStatus.AWAITING_ADMIN_CONFIRMATION,
  OrderStatus.AWAITING_MYID,
  OrderStatus.VERIFIED,
  OrderStatus.PREPARING,
  OrderStatus.READY_FOR_PICKUP,
  OrderStatus.HANDED_TO_DELIVERY,
  OrderStatus.DELIVERED,
  OrderStatus.RENTAL_ACTIVE,
  OrderStatus.AWAITING_RETURN
];
var FulfillmentType = {
  DELIVERY: "DELIVERY",
  PICKUP: "PICKUP"
};
var PaymentMethod = {
  CLICK: "CLICK",
  PAYME: "PAYME",
  CASH: "CASH"
};
var ONLINE_PAYMENT_METHODS = [
  PaymentMethod.CLICK,
  PaymentMethod.PAYME
];
var PaymentStatus = {
  PENDING: "PENDING",
  PAID: "PAID",
  CANCELLED: "CANCELLED",
  REFUNDED: "REFUNDED",
  FAILED: "FAILED"
};
var PaymentPurpose = {
  RENT: "RENT",
  DEPOSIT: "DEPOSIT",
  FINE: "FINE",
  LATE_FEE: "LATE_FEE"
};
var OrderPaymentStatus = {
  UNPAID: "UNPAID",
  PARTIALLY_PAID: "PARTIALLY_PAID",
  PAID: "PAID",
  REFUNDED: "REFUNDED"
};
var ActorType = {
  USER: "USER",
  ADMIN: "ADMIN",
  COURIER: "COURIER",
  SYSTEM: "SYSTEM"
};

// src/enums/rbac.ts
var AdminRole = {
  SUPER_ADMIN: "SUPER_ADMIN",
  ADMIN: "ADMIN",
  MANAGER: "MANAGER",
  WAREHOUSE: "WAREHOUSE",
  COURIER: "COURIER",
  CONTENT: "CONTENT"
};
var Permission = {
  // Каталог
  CATEGORY_VIEW: "category.view",
  CATEGORY_MANAGE: "category.manage",
  PRODUCT_VIEW: "product.view",
  PRODUCT_MANAGE: "product.manage",
  VARIANT_MANAGE: "variant.manage",
  ACCESSORY_MANAGE: "accessory.manage",
  DICTIONARY_MANAGE: "dictionary.manage",
  // Склад
  INVENTORY_VIEW: "inventory.view",
  INVENTORY_MANAGE: "inventory.manage",
  // Заказы
  ORDER_VIEW: "order.view",
  ORDER_CONFIRM: "order.confirm",
  ORDER_REJECT: "order.reject",
  ORDER_CANCEL: "order.cancel",
  ORDER_CHANGE_STATUS: "order.change_status",
  ORDER_DELIVER: "order.deliver",
  // Возвраты
  RETURN_ACCEPT: "return.accept",
  RETURN_INSPECT: "return.inspect",
  FINE_MANAGE: "fine.manage",
  // Финансы
  PAYMENT_VIEW: "payment.view",
  PAYMENT_REFUND: "payment.refund",
  // Маркетинг и контент
  PROMO_MANAGE: "promo.manage",
  BANNER_MANAGE: "banner.manage",
  OFFER_MANAGE: "offer.manage",
  // Клиенты
  CUSTOMER_VIEW: "customer.view",
  CUSTOMER_MANAGE: "customer.manage",
  // Уведомления
  NOTIFICATION_VIEW: "notification.view",
  NOTIFICATION_MANAGE: "notification.manage",
  // Система
  SETTINGS_MANAGE: "settings.manage",
  DELIVERY_MANAGE: "delivery.manage",
  ADMIN_MANAGE: "admin.manage",
  ROLE_MANAGE: "role.manage",
  AUDIT_VIEW: "audit.view",
  ANALYTICS_VIEW: "analytics.view"
};
var ALL_PERMISSIONS = Object.values(Permission);
var ROLE_PERMISSIONS = {
  [AdminRole.SUPER_ADMIN]: ALL_PERMISSIONS,
  [AdminRole.ADMIN]: ALL_PERMISSIONS.filter(
    (p) => p !== Permission.ADMIN_MANAGE && p !== Permission.ROLE_MANAGE
  ),
  [AdminRole.MANAGER]: [
    Permission.CATEGORY_VIEW,
    Permission.PRODUCT_VIEW,
    Permission.INVENTORY_VIEW,
    Permission.ORDER_VIEW,
    Permission.ORDER_CONFIRM,
    Permission.ORDER_REJECT,
    Permission.ORDER_CANCEL,
    Permission.ORDER_CHANGE_STATUS,
    Permission.RETURN_ACCEPT,
    Permission.PAYMENT_VIEW,
    Permission.CUSTOMER_VIEW,
    Permission.NOTIFICATION_VIEW,
    Permission.ANALYTICS_VIEW
  ],
  [AdminRole.WAREHOUSE]: [
    Permission.PRODUCT_VIEW,
    Permission.INVENTORY_VIEW,
    Permission.INVENTORY_MANAGE,
    Permission.ORDER_VIEW,
    Permission.ORDER_CHANGE_STATUS,
    Permission.RETURN_ACCEPT,
    Permission.RETURN_INSPECT,
    Permission.FINE_MANAGE
  ],
  [AdminRole.COURIER]: [Permission.ORDER_VIEW, Permission.ORDER_DELIVER],
  [AdminRole.CONTENT]: [
    Permission.CATEGORY_VIEW,
    Permission.CATEGORY_MANAGE,
    Permission.PRODUCT_VIEW,
    Permission.PRODUCT_MANAGE,
    Permission.VARIANT_MANAGE,
    Permission.ACCESSORY_MANAGE,
    Permission.DICTIONARY_MANAGE,
    Permission.BANNER_MANAGE
  ]
};

// src/enums/catalog.ts
var CATEGORY_ICONS = [
  "sparkles",
  "crown",
  "female",
  "male",
  "baby",
  "drama",
  "watch",
  "shirt"
];
var SizeGroupCode = {
  CLOTHING: "CLOTHING",
  SHOE: "SHOE",
  UNIVERSAL: "UNIVERSAL"
};
var DEFAULT_CLOTHING_SIZES = ["XS", "S", "M", "L", "XL", "XXL"];
var SHOE_SIZE_MIN = 10;
var SHOE_SIZE_MAX = 50;
var DEFAULT_SHOE_SIZES = Array.from(
  { length: SHOE_SIZE_MAX - SHOE_SIZE_MIN + 1 },
  (_, i) => String(SHOE_SIZE_MIN + i)
);
var PriceMode = {
  PER_DAY: "PER_DAY",
  FLAT: "FLAT"
};
var InventoryCondition = {
  NEW: "NEW",
  GOOD: "GOOD",
  WORN: "WORN",
  REPAIR: "REPAIR",
  WRITTEN_OFF: "WRITTEN_OFF"
};
var InventoryUnitStatus = {
  AVAILABLE: "AVAILABLE",
  RENTED: "RENTED",
  INSPECTION: "INSPECTION",
  REPAIR: "REPAIR",
  LOST: "LOST"
};
var ReservationStatus = {
  HELD: "HELD",
  CONFIRMED: "CONFIRMED",
  RELEASED: "RELEASED",
  COMPLETED: "COMPLETED"
};
var ACTIVE_RESERVATION_STATUSES = [
  ReservationStatus.HELD,
  ReservationStatus.CONFIRMED
];
var DiscountType = {
  PERCENT: "PERCENT",
  FIXED: "FIXED"
};
var PromoScope = {
  ALL: "ALL",
  CATEGORY: "CATEGORY",
  PRODUCT: "PRODUCT"
};
var DamageCalcMode = {
  FIXED: "FIXED",
  PERCENT_OF_DEPOSIT: "PERCENT_OF_DEPOSIT",
  PERCENT_OF_RENT: "PERCENT_OF_RENT"
};
var InspectionResult = {
  OK: "OK",
  DAMAGED: "DAMAGED",
  LOST: "LOST"
};
var ReturnStatus = {
  PENDING: "PENDING",
  IN_PROGRESS: "IN_PROGRESS",
  OK: "OK",
  DAMAGED: "DAMAGED",
  CLOSED: "CLOSED"
};
var InvoiceStatus = {
  ISSUED: "ISSUED",
  PAID: "PAID",
  CANCELLED: "CANCELLED",
  WRITTEN_OFF: "WRITTEN_OFF",
  DEDUCTED_FROM_DEPOSIT: "DEDUCTED_FROM_DEPOSIT"
};
var MyIdStatus = {
  NOT_REQUIRED: "NOT_REQUIRED",
  PENDING: "PENDING",
  IN_PROGRESS: "IN_PROGRESS",
  VERIFIED: "VERIFIED",
  FAILED: "FAILED"
};

// src/enums/notification.ts
var NotificationChannel = {
  TELEGRAM: "TELEGRAM",
  SMS: "SMS",
  PUSH: "PUSH"
};
var NotificationEvent = {
  OTP_SENT: "OTP_SENT",
  PAYMENT_SUCCESS: "PAYMENT_SUCCESS",
  PAYMENT_FAILED: "PAYMENT_FAILED",
  ORDER_CREATED: "ORDER_CREATED",
  ORDER_CONFIRMED: "ORDER_CONFIRMED",
  ORDER_REJECTED: "ORDER_REJECTED",
  ORDER_CANCELLED: "ORDER_CANCELLED",
  MYID_REQUIRED: "MYID_REQUIRED",
  MYID_VERIFIED: "MYID_VERIFIED",
  MYID_FAILED: "MYID_FAILED",
  DELIVERY_STARTED: "DELIVERY_STARTED",
  READY_FOR_PICKUP: "READY_FOR_PICKUP",
  RENTAL_STARTED: "RENTAL_STARTED",
  RETURN_REMINDER: "RETURN_REMINDER",
  RETURN_OVERDUE: "RETURN_OVERDUE",
  ITEM_RETURNED: "ITEM_RETURNED",
  INSPECTION_STARTED: "INSPECTION_STARTED",
  DAMAGE_DETECTED: "DAMAGE_DETECTED",
  FINE_ISSUED: "FINE_ISSUED",
  DEPOSIT_REFUNDED: "DEPOSIT_REFUNDED",
  ORDER_COMPLETED: "ORDER_COMPLETED"
};
var NOTIFICATION_EVENTS = Object.values(NotificationEvent);
var MANDATORY_NOTIFICATION_EVENTS = [
  NotificationEvent.OTP_SENT,
  NotificationEvent.PAYMENT_SUCCESS,
  NotificationEvent.PAYMENT_FAILED,
  NotificationEvent.MYID_REQUIRED,
  NotificationEvent.DAMAGE_DETECTED,
  NotificationEvent.FINE_ISSUED,
  NotificationEvent.RETURN_OVERDUE
];
var NotificationStatus = {
  QUEUED: "QUEUED",
  SENT: "SENT",
  FAILED: "FAILED"
};

// src/types/localized.ts
import { z } from "zod";
var localizedTextSchema = z.object({
  uz: z.string().trim().optional(),
  ru: z.string().trim().optional(),
  en: z.string().trim().optional()
}).refine((v) => LOCALES.some((l) => (v[l] ?? "").length > 0), {
  message: "\u041D\u0443\u0436\u043D\u043E \u0437\u0430\u043F\u043E\u043B\u043D\u0438\u0442\u044C \u0445\u043E\u0442\u044F \u0431\u044B \u043E\u0434\u0438\u043D \u044F\u0437\u044B\u043A"
});
var requiredLocalizedTextSchema = localizedTextSchema.and(
  z.object({ [DEFAULT_LOCALE]: z.string().trim().min(1) })
);
function pickLocalized(text, locale = DEFAULT_LOCALE) {
  if (!text) return "";
  const preferred = text[locale];
  if (preferred) return preferred;
  const fallback = text[DEFAULT_LOCALE];
  if (fallback) return fallback;
  for (const l of LOCALES) {
    const value = text[l];
    if (value) return value;
  }
  return "";
}

// src/money.ts
function sumToTiyin(sum) {
  return Math.round(sum * TIYIN_IN_SUM);
}
function tiyinToSum(tiyin) {
  return tiyin / TIYIN_IN_SUM;
}
function fromBigInt(value) {
  const n = Number(value);
  if (!Number.isSafeInteger(n)) {
    throw new RangeError(`\u0421\u0443\u043C\u043C\u0430 ${value} \u0432\u044B\u0445\u043E\u0434\u0438\u0442 \u0437\u0430 \u043F\u0440\u0435\u0434\u0435\u043B\u044B \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0433\u043E \u0446\u0435\u043B\u043E\u0433\u043E \u0447\u0438\u0441\u043B\u0430`);
  }
  return n;
}
function toBigInt(value) {
  return BigInt(Math.round(value));
}
function percentOf(amount, percent) {
  return Math.floor(amount * percent / 100);
}
function clampNonNegative(amount) {
  return amount < 0 ? 0 : amount;
}
function sumAll(amounts) {
  return amounts.reduce((acc, n) => acc + n, 0);
}
var LOCALE_TAGS = {
  uz: "uz-UZ",
  ru: "ru-RU",
  en: "en-US"
};
function formatMoney(tiyin, locale = "ru") {
  const formatted = new Intl.NumberFormat(LOCALE_TAGS[locale], {
    maximumFractionDigits: 0
  }).format(tiyinToSum(tiyin));
  const unit = { uz: "so'm", ru: "\u0441\u0443\u043C", en: "UZS" };
  return `${formatted} ${unit[locale]}`;
}

// src/date.ts
var DATE_ONLY_RE = /^\d{4}-\d{2}-\d{2}$/;
var MS_IN_DAY = 24 * 60 * 60 * 1e3;
function isDateOnly(value) {
  return DATE_ONLY_RE.test(value) && !Number.isNaN(Date.parse(`${value}T00:00:00Z`));
}
function assertDateOnly(value) {
  if (!isDateOnly(value)) {
    throw new TypeError(`\u041E\u0436\u0438\u0434\u0430\u043B\u0430\u0441\u044C \u0434\u0430\u0442\u0430 \u0432 \u0444\u043E\u0440\u043C\u0430\u0442\u0435 YYYY-MM-DD, \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u043E: ${value}`);
  }
  return value;
}
function toDateOnly(date) {
  return date.toISOString().slice(0, 10);
}
function parseDateOnly(value) {
  return /* @__PURE__ */ new Date(`${assertDateOnly(value)}T00:00:00.000Z`);
}
function addDays(value, days) {
  return toDateOnly(new Date(parseDateOnly(value).getTime() + days * MS_IN_DAY));
}
function diffDays(start, end) {
  return Math.round((parseDateOnly(end).getTime() - parseDateOnly(start).getTime()) / MS_IN_DAY);
}
function rentalDays(start, end) {
  const days = diffDays(start, end) + 1;
  if (days < 1) {
    throw new RangeError(`\u0414\u0430\u0442\u0430 \u043E\u043A\u043E\u043D\u0447\u0430\u043D\u0438\u044F ${end} \u0440\u0430\u043D\u044C\u0448\u0435 \u0434\u0430\u0442\u044B \u043D\u0430\u0447\u0430\u043B\u0430 ${start}`);
  }
  return days;
}
function eachDate(start, end) {
  const total = rentalDays(start, end);
  return Array.from({ length: total }, (_, i) => addDays(start, i));
}
function periodsOverlap(aStart, aEnd, bStart, bEnd) {
  return aStart <= bEnd && bStart <= aEnd;
}
function todayInTashkent(now = /* @__PURE__ */ new Date()) {
  return toDateOnly(new Date(now.getTime() + 5 * 60 * 60 * 1e3));
}

// src/slug.ts
var TRANSLIT = {
  \u0430: "a",
  \u0431: "b",
  \u0432: "v",
  \u0433: "g",
  \u0434: "d",
  \u0435: "e",
  \u0451: "e",
  \u0436: "zh",
  \u0437: "z",
  \u0438: "i",
  \u0439: "y",
  \u043A: "k",
  \u043B: "l",
  \u043C: "m",
  \u043D: "n",
  \u043E: "o",
  \u043F: "p",
  \u0440: "r",
  \u0441: "s",
  \u0442: "t",
  \u0443: "u",
  \u0444: "f",
  \u0445: "h",
  \u0446: "ts",
  \u0447: "ch",
  \u0448: "sh",
  \u0449: "sch",
  \u044A: "",
  \u044B: "y",
  \u044C: "",
  \u044D: "e",
  \u044E: "yu",
  \u044F: "ya",
  \u011F: "g",
  \u014D: "o",
  \u00E7: "ch",
  \u015F: "sh",
  \u02BB: "",
  \u02BC: "",
  "\u2018": "",
  "\u2019": ""
};
function slugify(input, maxLength = 120) {
  return input.toLowerCase().split("").map((char) => TRANSLIT[char] ?? char).join("").normalize("NFD").replace(/[̀-ͯ]/g, "").replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "").slice(0, maxLength).replace(/-+$/g, "");
}
function toCode(input, maxLength = 24) {
  return slugify(input, maxLength).toUpperCase().replace(/-/g, "_");
}

// src/availability.ts
function blockedRange(startDate, endDate, bufferDays = 0) {
  rentalDays(startDate, endDate);
  return { startDate, blockedUntil: addDays(endDate, bufferDays) };
}
function dailyLoad(bookings, from, to) {
  const load = /* @__PURE__ */ new Map();
  for (const date of eachDate(from, to)) {
    load.set(date, 0);
  }
  for (const booking of bookings) {
    if (!periodsOverlap(booking.startDate, booking.blockedUntil, from, to)) continue;
    const overlapStart = booking.startDate > from ? booking.startDate : from;
    const overlapEnd = booking.blockedUntil < to ? booking.blockedUntil : to;
    for (const date of eachDate(overlapStart, overlapEnd)) {
      load.set(date, (load.get(date) ?? 0) + booking.qty);
    }
  }
  return load;
}
function calendar(quantityTotal, bookings, from, to) {
  const load = dailyLoad(bookings, from, to);
  return eachDate(from, to).map((date) => {
    const reserved = load.get(date) ?? 0;
    return { date, reserved, free: Math.max(0, quantityTotal - reserved) };
  });
}
function minFree(quantityTotal, bookings, startDate, blockedUntil) {
  const load = dailyLoad(bookings, startDate, blockedUntil);
  let min = quantityTotal;
  for (const reserved of load.values()) {
    min = Math.min(min, quantityTotal - reserved);
  }
  return Math.max(0, min);
}
function isAvailable(quantityTotal, bookings, startDate, blockedUntil, qty = 1) {
  return minFree(quantityTotal, bookings, startDate, blockedUntil) >= qty;
}
function validatePeriod(startDate, endDate, limits, today) {
  if (endDate < startDate) return { kind: "REVERSED" };
  if (startDate < today) return { kind: "IN_PAST", today };
  const days = rentalDays(startDate, endDate);
  if (days < limits.minRentalDays) {
    return { kind: "TOO_SHORT", minRentalDays: limits.minRentalDays };
  }
  if (days > limits.maxRentalDays) {
    return { kind: "TOO_LONG", maxRentalDays: limits.maxRentalDays };
  }
  return null;
}

// src/pricing.ts
function calcItem(item) {
  const days = rentalDays(item.startDate, item.endDate);
  const rentTotal = item.pricePerDay * days * item.qty;
  const accessories = item.accessories ?? [];
  const accessoriesTotal = sumAll(accessories.map((a) => calcAccessory(a, days)));
  const depositTotal = (item.depositAmount ?? 0) * item.qty + sumAll(accessories.map((a) => (a.depositAmount ?? 0) * a.qty));
  return {
    days,
    rentTotal,
    accessoriesTotal,
    depositTotal,
    subtotal: rentTotal + accessoriesTotal
  };
}
function calcAccessory(accessory, days) {
  const multiplier = accessory.priceMode === PriceMode.PER_DAY ? days : 1;
  return accessory.price * multiplier * accessory.qty;
}
function calcCart(items) {
  const totals = items.map(calcItem);
  const itemsTotal = sumAll(totals.map((t) => t.rentTotal));
  const accessoriesTotal = sumAll(totals.map((t) => t.accessoriesTotal));
  return {
    itemsTotal,
    accessoriesTotal,
    depositTotal: sumAll(totals.map((t) => t.depositTotal)),
    subtotal: itemsTotal + accessoriesTotal
  };
}
function calcPromoDiscount(subtotal, promo) {
  if (!promo) return 0;
  if (promo.minOrderAmount && subtotal < promo.minOrderAmount) return 0;
  const raw = promo.discountType === DiscountType.PERCENT ? percentOf(subtotal, promo.value) : promo.value;
  const capped = promo.maxDiscount ? Math.min(raw, promo.maxDiscount) : raw;
  return Math.min(capped, subtotal);
}
var DepositMode = {
  /** Блокировка на карте без списания */
  HOLD: "HOLD",
  /** Списание с последующим возвратом */
  CHARGE: "CHARGE",
  /** Наличными при выдаче — в онлайн-платёж не входит */
  CASH_ON_PICKUP: "CASH_ON_PICKUP"
};
function calcOrderTotals(input) {
  const subtotal = input.itemsTotal + input.accessoriesTotal;
  const promoDiscount = calcPromoDiscount(subtotal, input.promo ?? null);
  const manualDiscount = Math.min(input.manualDiscount ?? 0, subtotal - promoDiscount);
  const discountTotal = promoDiscount + manualDiscount;
  const deliveryCost = input.deliveryCost ?? 0;
  const depositMode = input.depositMode ?? DepositMode.HOLD;
  const rentPayable = clampNonNegative(subtotal - discountTotal) + deliveryCost;
  const depositPayable = depositMode === DepositMode.CASH_ON_PICKUP ? 0 : input.depositTotal;
  return {
    itemsTotal: input.itemsTotal,
    accessoriesTotal: input.accessoriesTotal,
    subtotal,
    promoDiscount,
    manualDiscount,
    discountTotal,
    deliveryCost,
    depositTotal: input.depositTotal,
    payableNow: rentPayable,
    depositPayable,
    total: rentPayable + depositPayable
  };
}
function calcLateFee(pricePerDay, overdueDays, multiplier) {
  if (overdueDays <= 0) return 0;
  return Math.round(pricePerDay * multiplier) * overdueDays;
}
function calcCancellationCharge(params) {
  if (params.minutesSinceCreated <= params.freeWindowMinutes) return 0;
  return params.pricePerDay * params.chargeDays;
}
function canHoldDeposit(params) {
  return params.rentalDays + params.inspectionDays <= params.maxHoldDays;
}

// src/damages.ts
function calcDamageFine(damage, base) {
  if (damage.manualAmount !== void 0 && damage.manualAmount !== null) {
    return clampNonNegative(damage.manualAmount);
  }
  switch (damage.calcMode) {
    case DamageCalcMode.FIXED:
      return clampNonNegative(damage.value);
    case DamageCalcMode.PERCENT_OF_DEPOSIT:
      return percentOf(base.depositAmount, damage.value);
    case DamageCalcMode.PERCENT_OF_RENT:
      return percentOf(base.rentTotal, damage.value);
    default:
      return 0;
  }
}
function calcDamagesTotal(damages, base) {
  return sumAll(damages.map((damage) => calcDamageFine(damage, base)));
}
function settleDeposit(input) {
  const claimed = clampNonNegative(input.fineTotal) + clampNonNegative(input.lateFeeTotal ?? 0);
  const deposit = clampNonNegative(input.depositTotal);
  const withheld = Math.min(deposit, claimed);
  return {
    claimed,
    withheld,
    refund: deposit - withheld,
    outstanding: claimed - withheld
  };
}
function inspectionDeadline(returnedAt, deadlineDays) {
  return new Date(returnedAt.getTime() + deadlineDays * 24 * 60 * 60 * 1e3);
}

// src/templates.ts
var PLACEHOLDER = /\{\{\s*([a-zA-Z][a-zA-Z0-9_]*)\s*\}\}/g;
function renderTemplate(template, vars) {
  const missing = [];
  const text = template.replace(PLACEHOLDER, (match, name) => {
    const value = vars[name];
    if (value === void 0 || value === null || value === "") {
      if (!missing.includes(name)) missing.push(name);
      return match;
    }
    return String(value);
  });
  return { text, missing };
}
function templateVariables(template) {
  const found = /* @__PURE__ */ new Set();
  for (const match of template.matchAll(PLACEHOLDER)) {
    found.add(match[1]);
  }
  return [...found];
}
function validateTemplate(template, allowed) {
  const unknown = templateVariables(template).filter((name) => !allowed.includes(name));
  return { valid: unknown.length === 0, unknown };
}
var ORDER_TEMPLATE_VARS = [
  "orderNumber",
  "customerName",
  "amount",
  "depositAmount",
  "fineAmount",
  "refundAmount",
  "startDate",
  "endDate",
  "dueDate",
  "days",
  "address",
  "pickupPoint",
  "reason",
  "code"
];

// src/order-state-machine.ts
var onlineOnly = (ctx) => ctx.paymentMethod === PaymentMethod.CASH ? "\u041F\u0440\u0438 \u043D\u0430\u043B\u0438\u0447\u043D\u043E\u043C \u0440\u0430\u0441\u0447\u0451\u0442\u0435 MyID \u043D\u0435 \u043F\u0440\u043E\u0445\u043E\u0434\u0438\u0442\u0441\u044F \u2014 \u0437\u0430\u043A\u0430\u0437 \u0438\u0434\u0451\u0442 \u0441\u0440\u0430\u0437\u0443 \u0432 \u043F\u043E\u0434\u0433\u043E\u0442\u043E\u0432\u043A\u0443" : null;
var cashOnly = (ctx) => ctx.paymentMethod === PaymentMethod.CASH ? null : "\u041E\u043D\u043B\u0430\u0439\u043D-\u0437\u0430\u043A\u0430\u0437 \u0438\u0434\u0451\u0442 \u0447\u0435\u0440\u0435\u0437 MyID, \u0430 \u043D\u0435 \u043D\u0430\u043F\u0440\u044F\u043C\u0443\u044E \u0432 \u043F\u043E\u0434\u0433\u043E\u0442\u043E\u0432\u043A\u0443";
var pickupOnly = (ctx) => ctx.fulfillmentType === FulfillmentType.PICKUP ? null : "\u0417\u0430\u043A\u0430\u0437 \u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D \u043D\u0430 \u0434\u043E\u0441\u0442\u0430\u0432\u043A\u0443";
var deliveryOnly = (ctx) => ctx.fulfillmentType === FulfillmentType.DELIVERY ? null : "\u0417\u0430\u043A\u0430\u0437 \u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D \u043D\u0430 \u0441\u0430\u043C\u043E\u0432\u044B\u0432\u043E\u0437";
var passportReturned = (ctx) => ctx.passportHeld ? "\u041F\u0430\u0441\u043F\u043E\u0440\u0442 \u043A\u043B\u0438\u0435\u043D\u0442\u0430 \u0435\u0449\u0451 \u043D\u0430 \u0445\u0440\u0430\u043D\u0435\u043D\u0438\u0438 \u2014 \u0432\u0435\u0440\u043D\u0438\u0442\u0435 \u0435\u0433\u043E \u043F\u0435\u0440\u0435\u0434 \u0437\u0430\u043A\u0440\u044B\u0442\u0438\u0435\u043C" : null;
var CANCELLABLE_STATUSES = [
  OrderStatus.NEW,
  OrderStatus.AWAITING_PAYMENT,
  OrderStatus.PAID,
  OrderStatus.AWAITING_ADMIN_CONFIRMATION,
  OrderStatus.AWAITING_MYID,
  OrderStatus.VERIFIED,
  OrderStatus.PREPARING,
  OrderStatus.READY_FOR_PICKUP,
  OrderStatus.HANDED_TO_DELIVERY,
  OrderStatus.DELIVERED
];
var SELF_CANCELLABLE_STATUSES = [
  OrderStatus.NEW,
  OrderStatus.AWAITING_PAYMENT,
  OrderStatus.PAID,
  OrderStatus.AWAITING_ADMIN_CONFIRMATION,
  OrderStatus.AWAITING_MYID,
  OrderStatus.VERIFIED
];
var FLOW = [
  // ── Онлайн-оплата ──────────────────────────────────────────────
  {
    from: OrderStatus.NEW,
    to: OrderStatus.AWAITING_PAYMENT,
    allowedActors: [ActorType.SYSTEM],
    label: "\u0412\u044B\u0441\u0442\u0430\u0432\u043B\u0435\u043D \u0441\u0447\u0451\u0442"
  },
  {
    from: OrderStatus.AWAITING_PAYMENT,
    to: OrderStatus.PAID,
    allowedActors: [ActorType.SYSTEM],
    label: "\u041E\u043F\u043B\u0430\u0442\u0430 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0430"
  },
  {
    from: OrderStatus.PAID,
    to: OrderStatus.AWAITING_ADMIN_CONFIRMATION,
    allowedActors: [ActorType.SYSTEM],
    label: "\u041F\u0435\u0440\u0435\u0434\u0430\u043D \u043D\u0430 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435"
  },
  // ── Подтверждение администратором ──────────────────────────────
  {
    from: OrderStatus.AWAITING_ADMIN_CONFIRMATION,
    to: OrderStatus.AWAITING_MYID,
    allowedActors: [ActorType.ADMIN],
    requiredPermission: Permission.ORDER_CONFIRM,
    guard: onlineOnly,
    label: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0451\u043D, \u043E\u0436\u0438\u0434\u0430\u0435\u0442 MyID"
  },
  {
    from: OrderStatus.AWAITING_ADMIN_CONFIRMATION,
    to: OrderStatus.PREPARING,
    allowedActors: [ActorType.ADMIN],
    requiredPermission: Permission.ORDER_CONFIRM,
    guard: cashOnly,
    label: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0451\u043D, \u0432\u0437\u044F\u0442 \u0432 \u0440\u0430\u0431\u043E\u0442\u0443"
  },
  {
    from: OrderStatus.AWAITING_MYID,
    to: OrderStatus.VERIFIED,
    allowedActors: [ActorType.SYSTEM],
    label: "\u0412\u0435\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F MyID \u043F\u0440\u043E\u0439\u0434\u0435\u043D\u0430"
  },
  {
    from: OrderStatus.VERIFIED,
    to: OrderStatus.PREPARING,
    allowedActors: [ActorType.ADMIN],
    requiredPermission: Permission.ORDER_CHANGE_STATUS,
    label: "\u0412\u0437\u044F\u0442 \u0432 \u0440\u0430\u0431\u043E\u0442\u0443"
  },
  // ── Выдача ─────────────────────────────────────────────────────
  {
    from: OrderStatus.PREPARING,
    to: OrderStatus.READY_FOR_PICKUP,
    allowedActors: [ActorType.ADMIN],
    requiredPermission: Permission.ORDER_CHANGE_STATUS,
    guard: pickupOnly,
    label: "\u0413\u043E\u0442\u043E\u0432 \u043A \u0432\u044B\u0434\u0430\u0447\u0435"
  },
  {
    from: OrderStatus.PREPARING,
    to: OrderStatus.HANDED_TO_DELIVERY,
    allowedActors: [ActorType.ADMIN],
    requiredPermission: Permission.ORDER_CHANGE_STATUS,
    guard: deliveryOnly,
    label: "\u041F\u0435\u0440\u0435\u0434\u0430\u043D \u043A\u0443\u0440\u044C\u0435\u0440\u0443"
  },
  {
    from: OrderStatus.READY_FOR_PICKUP,
    to: OrderStatus.RENTAL_ACTIVE,
    allowedActors: [ActorType.ADMIN],
    requiredPermission: Permission.ORDER_CHANGE_STATUS,
    label: "\u0412\u044B\u0434\u0430\u043D \u043A\u043B\u0438\u0435\u043D\u0442\u0443"
  },
  {
    from: OrderStatus.HANDED_TO_DELIVERY,
    to: OrderStatus.DELIVERED,
    allowedActors: [ActorType.COURIER, ActorType.ADMIN],
    requiredPermission: Permission.ORDER_DELIVER,
    label: "\u0414\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D"
  },
  {
    from: OrderStatus.DELIVERED,
    to: OrderStatus.RENTAL_ACTIVE,
    allowedActors: [ActorType.SYSTEM],
    label: "\u0410\u0440\u0435\u043D\u0434\u0430 \u043D\u0430\u0447\u0430\u043B\u0430\u0441\u044C"
  },
  // ── Возврат и инспекция ────────────────────────────────────────
  {
    from: OrderStatus.RENTAL_ACTIVE,
    to: OrderStatus.AWAITING_RETURN,
    allowedActors: [ActorType.SYSTEM],
    label: "\u041E\u0436\u0438\u0434\u0430\u0435\u0442 \u0432\u043E\u0437\u0432\u0440\u0430\u0442\u0430"
  },
  {
    from: OrderStatus.AWAITING_RETURN,
    to: OrderStatus.RETURNED,
    allowedActors: [ActorType.ADMIN],
    requiredPermission: Permission.ORDER_CHANGE_STATUS,
    label: "\u0412\u0435\u0449\u044C \u043F\u0440\u0438\u043D\u044F\u0442\u0430"
  },
  {
    from: OrderStatus.RETURNED,
    to: OrderStatus.WAREHOUSE_INSPECTION,
    allowedActors: [ActorType.SYSTEM],
    label: "\u041E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D \u043D\u0430 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0443"
  },
  {
    from: OrderStatus.WAREHOUSE_INSPECTION,
    to: OrderStatus.COMPLETED,
    allowedActors: [ActorType.ADMIN, ActorType.SYSTEM],
    requiredPermission: Permission.ORDER_CHANGE_STATUS,
    guard: passportReturned,
    label: "\u041F\u0440\u043E\u0432\u0435\u0440\u043A\u0430 \u043F\u0440\u043E\u0439\u0434\u0435\u043D\u0430, \u0437\u0430\u043A\u0430\u0437 \u0437\u0430\u043A\u0440\u044B\u0442"
  },
  {
    from: OrderStatus.WAREHOUSE_INSPECTION,
    to: OrderStatus.DAMAGE_DETECTED,
    allowedActors: [ActorType.ADMIN],
    requiredPermission: Permission.ORDER_CHANGE_STATUS,
    label: "\u041E\u0431\u043D\u0430\u0440\u0443\u0436\u0435\u043D\u043E \u043F\u043E\u0432\u0440\u0435\u0436\u0434\u0435\u043D\u0438\u0435"
  },
  {
    from: OrderStatus.DAMAGE_DETECTED,
    to: OrderStatus.FINE_ISSUED,
    allowedActors: [ActorType.ADMIN],
    requiredPermission: Permission.ORDER_CHANGE_STATUS,
    label: "\u0412\u044B\u0441\u0442\u0430\u0432\u043B\u0435\u043D \u0448\u0442\u0440\u0430\u0444"
  },
  {
    from: OrderStatus.FINE_ISSUED,
    to: OrderStatus.COMPLETED,
    allowedActors: [ActorType.ADMIN],
    requiredPermission: Permission.ORDER_CHANGE_STATUS,
    guard: passportReturned,
    label: "\u0428\u0442\u0440\u0430\u0444 \u0437\u0430\u043A\u0440\u044B\u0442, \u0437\u0430\u043A\u0430\u0437 \u0437\u0430\u0432\u0435\u0440\u0448\u0451\u043D"
  },
  // ── Отмена ─────────────────────────────────────────────────────
  ...CANCELLABLE_STATUSES.map((from) => ({
    from,
    to: OrderStatus.CANCELLED,
    allowedActors: SELF_CANCELLABLE_STATUSES.includes(from) ? [ActorType.ADMIN, ActorType.USER, ActorType.SYSTEM] : [ActorType.ADMIN, ActorType.SYSTEM],
    requiredPermission: Permission.ORDER_CANCEL,
    label: "\u0417\u0430\u043A\u0430\u0437 \u043E\u0442\u043C\u0435\u043D\u0451\u043D"
  }))
];
var ORDER_TRANSITIONS = FLOW;
function canTransition(params) {
  const { from, to, actor, context, permissions } = params;
  if (from === to) return { allowed: false, reason: "\u0417\u0430\u043A\u0430\u0437 \u0443\u0436\u0435 \u0432 \u044D\u0442\u043E\u043C \u0441\u0442\u0430\u0442\u0443\u0441\u0435" };
  if (TERMINAL_ORDER_STATUSES.includes(from)) {
    return { allowed: false, reason: "\u0417\u0430\u043A\u0430\u0437 \u0437\u0430\u0432\u0435\u0440\u0448\u0451\u043D, \u0441\u0442\u0430\u0442\u0443\u0441 \u0431\u043E\u043B\u044C\u0448\u0435 \u043D\u0435 \u043C\u0435\u043D\u044F\u0435\u0442\u0441\u044F" };
  }
  const transition = FLOW.find((t) => t.from === from && t.to === to);
  if (!transition) {
    return { allowed: false, reason: `\u041F\u0435\u0440\u0435\u0445\u043E\u0434 ${from} \u2192 ${to} \u043D\u0435 \u043F\u0440\u0435\u0434\u0443\u0441\u043C\u043E\u0442\u0440\u0435\u043D` };
  }
  if (!transition.allowedActors.includes(actor)) {
    return { allowed: false, reason: "\u042D\u0442\u043E\u0442 \u043F\u0435\u0440\u0435\u0445\u043E\u0434 \u0432\u044B\u043F\u043E\u043B\u043D\u044F\u0435\u0442 \u043D\u0435 \u0442\u0435\u043A\u0443\u0449\u0430\u044F \u0440\u043E\u043B\u044C", transition };
  }
  if (transition.requiredPermission && actor !== ActorType.SYSTEM) {
    if (!permissions?.includes(transition.requiredPermission)) {
      return { allowed: false, reason: "\u041D\u0435\u0434\u043E\u0441\u0442\u0430\u0442\u043E\u0447\u043D\u043E \u043F\u0440\u0430\u0432 \u0434\u043B\u044F \u044D\u0442\u043E\u0433\u043E \u043F\u0435\u0440\u0435\u0445\u043E\u0434\u0430", transition };
    }
  }
  const blocked = transition.guard?.(context);
  if (blocked) return { allowed: false, reason: blocked, transition };
  return { allowed: true, transition };
}
function nextStatuses(params) {
  return FLOW.filter(
    (t) => t.from === params.from && canTransition({ ...params, to: t.to }).allowed
  );
}
export {
  ACTIVE_RESERVATION_STATUSES,
  ALL_PERMISSIONS,
  ActorType,
  AdminRole,
  CANCELLABLE_STATUSES,
  CATEGORY_ICONS,
  CURRENCY,
  DEFAULT_CLOTHING_SIZES,
  DEFAULT_LOCALE,
  DEFAULT_SHOE_SIZES,
  DamageCalcMode,
  DepositMode,
  DiscountType,
  FulfillmentType,
  InspectionResult,
  InventoryCondition,
  InventoryUnitStatus,
  InvoiceStatus,
  LOCALES,
  Locale,
  MANDATORY_NOTIFICATION_EVENTS,
  MyIdStatus,
  NOTIFICATION_EVENTS,
  NotificationChannel,
  NotificationEvent,
  NotificationStatus,
  ONLINE_PAYMENT_METHODS,
  ORDER_STATUSES,
  ORDER_TEMPLATE_VARS,
  ORDER_TRANSITIONS,
  OrderPaymentStatus,
  OrderStatus,
  PROJECT_TIMEZONE,
  PaymentMethod,
  PaymentPurpose,
  PaymentStatus,
  Permission,
  PriceMode,
  PromoScope,
  RESERVING_ORDER_STATUSES,
  ROLE_PERMISSIONS,
  ReservationStatus,
  ReturnStatus,
  SELF_CANCELLABLE_STATUSES,
  SHOE_SIZE_MAX,
  SHOE_SIZE_MIN,
  SizeGroupCode,
  TERMINAL_ORDER_STATUSES,
  TIYIN_IN_SUM,
  addDays,
  assertDateOnly,
  blockedRange,
  calcAccessory,
  calcCancellationCharge,
  calcCart,
  calcDamageFine,
  calcDamagesTotal,
  calcItem,
  calcLateFee,
  calcOrderTotals,
  calcPromoDiscount,
  calendar,
  canHoldDeposit,
  canTransition,
  clampNonNegative,
  dailyLoad,
  diffDays,
  eachDate,
  formatMoney,
  fromBigInt,
  inspectionDeadline,
  isAvailable,
  isDateOnly,
  localizedTextSchema,
  minFree,
  nextStatuses,
  parseDateOnly,
  percentOf,
  periodsOverlap,
  pickLocalized,
  renderTemplate,
  rentalDays,
  requiredLocalizedTextSchema,
  settleDeposit,
  slugify,
  sumAll,
  sumToTiyin,
  templateVariables,
  tiyinToSum,
  toBigInt,
  toCode,
  toDateOnly,
  todayInTashkent,
  validatePeriod,
  validateTemplate
};
//# sourceMappingURL=index.js.map